export const READ_SOURCE_TYPES = [
  "session",
  "form",
  "observation",
  "meeting_note",
] as const;

export type ReadSourceType = (typeof READ_SOURCE_TYPES)[number];

export interface ReadSourceRef {
  type: ReadSourceType;
  id: string;
}

export function isReadSourceType(value: unknown): value is ReadSourceType {
  return typeof value === "string" && READ_SOURCE_TYPES.includes(value as ReadSourceType);
}
